import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export async function apiMarkAsReadOrUnread(uid: string) {
  const url = occUrl(`/notifications/markAsReadOrUnread?uid=${uid}`);

  const response = await occFetch(url, {
    method: "POST",
  });

  return await response.json();
}
